import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPingdomComponent } from './simple-icons-pingdom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPingdomComponent ],
    exports:      [ SimpleIconsPingdomComponent ],
    bootstrap:    []
})
export class SimpleIconsPingdomModule {}
